import React, { Component } from 'react';
import EmployeeStatistic from './EmployeeStatistic';
import { formatMinutesToHoursWithMinutes} from './../../../../utilities/calendarUtilities';
import { formatRelativeSeniority} from './helpers';
import { statisticFields } from './../../../../settings/settings.json';
import { useLanguage } from '../../../../context/LanguageContext';

import './styles.scss';

class EmployeeStatistics extends Component {

  generateStatisticDataForAllActiveFields(employeeStatisticsByStatisticField) {
    return statisticFields.map((keyData, index) => {
      const statistic = employeeStatisticsByStatisticField[keyData];
      return this.isValidStatisticData(statistic.data) &&  <EmployeeStatistic key={index} header={statistic.label} data={statistic.data} />
    });
  }

  isValidStatisticData(data) {
    const employeeStatistics = this.props.labels?.employeeStatistics || {};
    return data && data !== employeeStatistics.NOT_APPLICABLE && data !== employeeStatistics.ZERO_CREDIT_HOURS;
  }

  render () {
    const employeeStatistics = this.props.labels?.employeeStatistics || {};
    const user = this.props.user;
    const enableSeniority = window.properties ? window.properties.displaySeniority : true;
    const seniorityRelativeToTotalOfCategoryEmployees = formatRelativeSeniority(user.relativeSeniority, user.totalOfCategoryEmployees);
    const minimumBlockTimeInHourMinute = user.minimumBlockTime !== null ? formatMinutesToHoursWithMinutes(user.minimumBlockTime): employeeStatistics.NOT_APPLICABLE;
    const maximumBlockTimeInHourMinute = user.maximumBlockTime !== null ? formatMinutesToHoursWithMinutes(user.maximumBlockTime): employeeStatistics.NOT_APPLICABLE;
    const previousPeriodCreditInHourMinute = formatMinutesToHoursWithMinutes(user.previousPeriodCredit);
    const initialCreditInHourMinute = user.initialCredit !== null ? formatMinutesToHoursWithMinutes(user.initialCredit) : employeeStatistics.NOT_APPLICABLE;

    const employeeStatisticsByStatisticField = {
      relativeSeniority: enableSeniority ? { label: employeeStatistics.relativeSeniority, data: seniorityRelativeToTotalOfCategoryEmployees } : { label: null, data: null},
      minimumBlockTime: {label: employeeStatistics.minimumBlockTime, data: minimumBlockTimeInHourMinute},
      maximumBlockTime: {label: employeeStatistics.maximumBlockTime, data: maximumBlockTimeInHourMinute},
      previousPeriodCredit: {label: employeeStatistics.previousPeriodCredit, data: previousPeriodCreditInHourMinute},
      initialCredit: {label: employeeStatistics.initialCredit, data: initialCreditInHourMinute}
    };

    return (
      <div className="personalInformationStatisticsTable">
        {this.generateStatisticDataForAllActiveFields(employeeStatisticsByStatisticField)}
      </div>
    );
  }
}

function EmployeeStatisticsWrapper(props) {
  const { labels } = useLanguage();
  return <EmployeeStatistics {...props} labels={labels} />;
}

export default EmployeeStatisticsWrapper;
